<template>
  <div v-loading="loading" class="execute-reimbursement">
    <div class="fixedButton" style="margin-top:10px">
      <vxe-button class="examineButton" @click="ReturnFun(0)">返回</vxe-button>
      <vxe-button status="success" class="examineButton" @click="saveFun">保存</vxe-button>
    </div>
    <!-- 查看 -->
    <div class="ActivityPlanReviewExamine scrollBars" :style="`height:${$store.state.app.height - 70}px;`">
      <el-collapse v-model="activityinfo" class="collapse-box">
        <el-collapse-item class="collapseItem" title="活动信息">
          <!-- 活动计划信息 -->
          <ActivityMaintenanceInformation :data="activity" />
          <!-- 活动提报信息 -->
          <ActivityReportingInformation :data="signData" :activity="activity" :file-list="fileList.actPlanApply" :approveBtnType="approveBtnType" />
        </el-collapse-item>
      </el-collapse>
      <!-- 反馈信息 -->
      <el-collapse v-model="collapseNumber" class="collapse-box">
        <el-collapse-item class="collapseItem" title="活动核销信息" name="default">
          <el-form ref="formOne" class="UniformCss" :model="signData" label-width="130px">
            <!-- <el-row v-if="remainFeeFlag">
              <el-col :span="6">
                <el-form-item class="form-item">
                  <span slot="label">
                    本期剩余核销费用(元)
                    <el-tooltip class="item" effect="dark" content="剩余费用=账期总费用-已提报活动核销费用之和" placement="top-start">
                      <i class="el-icon-info" style="font-size: 12px;color: #606266" />
                    </el-tooltip>
                  </span>
                  <el-input v-model="amountData.remainFee" disabled />
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="8">
                <el-form-item class="form-item" label="提报审批金额">
                  <el-input v-model="signData.approveApplyCost" disabled  />
                </el-form-item>
              </el-col>

              <!-- <el-col :span="12">
                <el-form-item class="form-item" label="反馈时间" prop="feedBackTime" :rules="[{ required: true, message: '请选择反馈时间!', trigger: 'blur' }]">
                  <el-date-picker v-model="signData.feedBackTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" />
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item class="form-item" label="实际时间" prop="actualStartTime" :rules="[{ required: true, message: '请选择实际开始时间!', trigger: 'blur' }]">
                  <el-date-picker
                    v-model="signData.actualStartTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                    @change="signData.actualEndTime ? (signData.actualEndTime = '') : ''"
                  />
                </el-form-item>
              </el-col>

              <!-- <el-col :span="12">
                <el-form-item class="form-item" label="实际结束时间" prop="actualEndTime" :rules="[{ required: true, message: '请选择实际结束时间!', trigger: 'blur' }]">
                  <el-date-picker
                    v-model="signData.actualEndTime"
                    :picker-options="{ disabledDate: time => time.getTime() < new Date(signData.actualStartTime ? signData.actualStartTime : '') }"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  />
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
              <el-form-item class="form-item" label="现场订车数" prop="orderQuantity">
                <el-input-number v-model="signData.orderQuantity" controls-position="right" :min="0" :controls="false"  />
              </el-form-item>
              </el-col>
              <!-- <el-form-item class="form-item" label="核销费用(元)" prop="thisWriteoffCost" :rules="[{ required: true, message: '请输入核销费用!', trigger: 'blur' }]">
                <el-input-number v-model="signData.thisWriteoffCost*" :precision="2" controls-position="right" :max="9000000000000" :controls="false" style="width: 220px;" disabled/>
              </el-form-item> -->
            </el-row>

            <el-row>
              <div class="item-line">审核费用确认明细</div>
              <a-col
                  v-for="f in activityVisibilityMap[getFormByActivity(activity.threeLevelName)]"
                  :key="f"
                  :span="6">
                <el-form-item class="form-item" :label="activityFeeFieldList[f].label">
                  <a-input-number
                      :min="activityFeeFieldList[f].min"
                      v-model="signData[f]"
                      @blur="setZeroIfEmpty(f)"
                      @change="getActualCost"
                      :disabled="isDisabled()"/>
                </el-form-item>
              </a-col>
              <el-col :span="8">
                <!-- <el-form-item class="form-item" label="实际执行费用(元)" prop="actualCost" :rules="[{ required: true, message: '请输入实际执行费用!', trigger: 'blur' }]">
                  <el-input-number v-model="signData.actualCost" :precision="2" controls-position="right" :min="0.00" :max="9000000000000.00" :controls="false"  style="width: 220px;"/>
                </el-form-item> -->


                <el-form-item class="form-item" label="实际执行费用(元)" prop="actualCost" v-show="false"
                  :rules="[
                    { required: true, message: '请输入实际执行费用!', trigger: 'blur' },
                    { validator: validateActualCost, trigger: 'blur' }
                  ]">
                  <el-input-number
                    v-model="signData.actualCost"
                    :precision="2"
                    controls-position="right"
                    :min="0.00"
                    :max="9000000000000.00"
                    :controls="false"
                    style="width: 220px;"
                    disabled
                 />
               </el-form-item>
              </el-col>
              <!-- :value="signData.actualCost * (activity.writeRate / 100)"  -->
              <el-col :span="6">
                <el-form-item class="form-item" label="核销审核费用(元)" prop="writeoffApproveFee">
                  <el-input-number
                    :value="signData.actualCost * (activity.writeRate / 100)"
                    :precision="2"
                    controls-position="right"
                    :max="signData.approveApplyCost * (activity.writeRate / 100)"
                    :controls="false"
                    style="width: 165px;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>

              <!-- <el-row>
              <el-col :span="12">
                <el-form-item class="form-item" label="开票时间">
                  <el-date-picker
                    style="width:220px"
                    @change="onTimeChange"
                    v-model="invoicingTime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <a-col :span="12">
                <el-form-item class="form-item" label="开票数">
                  <a-input
                   style="width:220px"
                    v-model="invoicingNumber" disabled>
                  </a-input>
                </el-form-item>
              </a-col>
            </el-row> -->

            <el-row>
              <el-col :span="12" style="height: auto">
                <el-form-item class="sign-item" label="增值税发票">  <!-- 发票 -->
                  <el-upload
                    ref="uploadInvoice"
                    class="upload-demo"
                    action=""
                    :before-upload="beforeUpload"
                    :on-change="handleChange1"
                    :on-preview="onPreviewFun"
                    :on-remove="handleRemove1"
                    :before-remove="beforeRemove1"
                    :http-request="uploadHttpRequest1"
                    :file-list="fileList.planWriteOffVatInvoice"
                    :auto-upload="false"
                    accept="image/*"
                    :limit="10"
                    :multiple="true"
                  >
                    <vxe-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" status="primary">选取图片</vxe-button>
                    <!-- <vxe-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload(1)">上传到服务器</vxe-button> -->
                    <!-- <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" style="height: auto">
                <el-form-item class="sign-item" label="过路费发票">     <!-- 发票真伪查验截图 -->
                  <el-upload
                    ref="uploadCapture"
                    class="upload-demo"
                    action=""
                    :before-upload="beforeUpload"
                    :on-change="handleChange3"
                    :on-preview="onPreviewFun"
                    :on-remove="handleRemove3"
                    :before-remove="beforeRemove3"
                    :http-request="uploadHttpRequest3"
                    :file-list="fileList.planWriteOffTollInvoice"
                    :auto-upload="false"
                    accept="image/*"
                    :limit="10"
                    :multiple="true"
                  >
                    <vxe-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" status="primary">选取图片</vxe-button>
                    <!-- <vxe-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload(3)">上传到服务器</vxe-button> -->
                    <!-- <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" style="height: auto">
                <el-form-item class="sign-tiem" label="加油费发票">
                  <el-upload
                    ref="uploadFuelCost"
                    class="upload-demo"
                    action=""
                    :before-upload="beforeUpload"
                    :on-change="handleChange6"
                    :on-preview="onPreviewFun"
                    :on-remove="handleRemove6"
                    :before-remove="beforeRemove6"
                    :http-request="uploadHttpRequest6"
                    :file-list="fileList.planWriteOffFuelInvoice"
                    :auto-upload="false"
                    accept="image/*"
                    :limit="10"
                    :multiple="true"
                  >
                    <vxe-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" status="primary">选取图片</vxe-button>
                    <!-- <vxe-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload(5)">上传到服务器</vxe-button> -->
                    <!-- <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" style="height: auto">
                <el-form-item class="sign-tiem" label="费用凭证">
                  <el-upload
                    ref="uploadVoucher"
                    class="upload-demo"
                    action=""
                    :before-upload="beforeUpload"
                    :on-change="handleChange4"
                    :on-preview="onPreviewFun"
                    :on-remove="handleRemove4"
                    :before-remove="beforeRemove4"
                    :http-request="uploadHttpRequest4"
                    :file-list="fileList.planWriteOffVoucher"
                    :auto-upload="false"
                  >
                    <vxe-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" status="primary">选取文件</vxe-button>
                    <!-- <vxe-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload(4)">上传到服务器</vxe-button> -->
                    <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div>
                    <div slot="tip" class="el-upload__tip">上传的费用凭证需要标注好名称和发票一一对应</div>

                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" style="height: auto">
                <el-form-item class="sign-item" label="合同">
                  <el-upload
                    ref="uploadContract"
                    class="upload-demo"
                    action=""
                    :before-upload="beforeUpload"
                    :on-change="handleChange2"
                    :on-preview="onPreviewFun"
                    :on-remove="handleRemove2"
                    :before-remove="beforeRemove2"
                    :http-request="uploadHttpRequest2"
                    :file-list="fileList.planWriteOffContract"
                    :auto-upload="false"
                  >
                    <vxe-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" status="primary">选取文件</vxe-button>
                    <!-- <vxe-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload(2)">上传到服务器</vxe-button> -->
                    <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" style="height: auto">
                <el-form-item class="form-item" label="活动照片">
                  <el-upload
                      ref="upload"
                      :disabled="true"
                      action="#"
                      :auto-upload="false"
                  >
                    <vxe-button icon="el-icon-circle-plus-outline" status="primary" @click="openPicDialog">选择图片</vxe-button>
                    <vxe-button
                        v-if="selectImgInfoList.length > 0"
                        icon="el-icon-download"
                        status="primary"
                        :loading="downLoading"
                        @click="onDownloadPic(0)"
                    >下载图片</vxe-button>
                  </el-upload>
                  <div v-if="selectImgInfoList.length>0" class="pic-box scrollBars">
                    <div v-for=" (item, index) in selectImgInfoList" :key="index" class="image-item2">
                      <el-image
                          style="width: 180px; height:180px;"
                          :src="item.url"
                          :preview-src-list="selectImgInfoList.map(val => val.url)"
                          lazy
                          fit="cover"
                      >
                        <div slot="placeholder" class="image-slot">
                          <i class="el-icon-loading" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" style="height: auto">
                <el-form-item class="sign-tiem" label="其他材料附件">
                  <el-upload
                    ref="uploadAttachment"
                    class="upload-demo"
                    action=""
                    :before-upload="beforeUpload"
                    :on-change="handleChange5"
                    :on-preview="onPreviewFun"
                    :on-remove="handleRemove5"
                    :before-remove="beforeRemove5"
                    :http-request="uploadHttpRequest5"
                    :file-list="fileList.planWriteOffAttachments"
                    :auto-upload="false"
                  >
                    <vxe-button slot="trigger" icon="el-icon-circle-plus-outline" size="small" status="primary">选取文件</vxe-button>
                    <!-- <vxe-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload(5)">上传到服务器</vxe-button> -->
                    <div slot="tip" class="el-upload__tip">一次只能上传一个文件，且不超过20M</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </el-collapse-item>
      </el-collapse>
      <!-- </div> -->
      <!-- 历史信息 -->
      <checkHistory :find-hist-tasks-data="findHistTasksData" :writeoff-task-data="findWriteoffTasksData" />
      <!-- <checkHistory
      :find-hist-tasks-data="findHistTasksData"
      :writeoff-task-data="findWriteoffTasksData"
      :sign-data="signData"
      :activity="activity"
    /> -->

      <!-- 对话框 -->

      <!-- 选择乘龙图片库执行照片上传 -->
      <el-dialog title="乘龙图片库" :visible.sync="PictureBase.OutBox" :close-on-click-modal="false" width="45%">
        <div v-if="allImgInfoList.length > 0">
          <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
          <vxe-button
            status="primary"
            icon="el-icon-download"
            style="margin:0 0 10px 70%;"
            :loading="downLoading"
            @click="onDownloadPic(1)"
          >下载图片</vxe-button>
          <div style="margin: 15px 0;" />
          <div class="picDialog scrollBars">
            <div v-for="item in allImgInfoList" :key="item.id" class="image-item">
              <div class="img">
                <el-image
                  style="width: 180px; height: 180px;"
                  :src="item.url"
                  fit="cover"
                  lazy
                  :preview-src-list="allImgInfoList.map(item => item.url)"
                >
                  <div slot="placeholder" class="image-slot">
                    <i class="el-icon-loading" />
                  </div>
                </el-image>
              </div>
              <div class="checkbox" style="position:absolute;top:5px;right:5px;z-index:1000;zoom:150%">
                <el-checkbox v-model="item.checked" @change="handleCheckedImgsChange" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="null-tip">
          暂无图片
        </div>
        <span slot="footer" class="dialog-footer">
          <vxe-button @click="onCancelSelect">取 消</vxe-button>
          <vxe-button status="primary" :loading="imgLoading" @click="PictureBaseFun">确 定</vxe-button>
        </span>
      </el-dialog>
    </div>
    <!-- <activityReimbursement /> -->
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import ActivityMaintenanceInformation from '../MarketActivityComponents/ActivityMaintenanceInformation.vue'
import ActivityReportingInformation from '../MarketActivityComponents/ActivityReportingInformation.vue'
import checkHistory from '../components/checkHistory.vue'
// import activityReimbursement from '../components/activityReimbursement/index.vue'
import JSZip from 'jszip'
// import { Message } from 'element-ui';
import {activityFeeFieldList, activityFormMap, activityVisibilityMap} from '@/utils/index.js'

import {
  findDealerActById, getActApplyDetail,
  saveWriteOffInfo, uploadPlanFiles, findFileInfo,
  getCameraPictures, confirmPictures, deleteFile, getCarInvoiceCount
} from '@/api/actPlan.js'
// import {
//   findDealerActById, getActApplyDetail,
//   uploadPlanFiles, findFileInfo,
//   getCameraPictures, confirmPictures, deleteFile, getCarInvoiceCount
// } from '@/api/actPlan.js'

import { getRemainFee } from '@/api/amount'

import { findTaskInfos } from '@/api/wf_process.js'

const defaultFileTypeMap = new Map([
  [1, 'planWriteOffVatInvoice'],
  [2, 'planWriteOffContract'],
  [3, 'planWriteOffTollInvoice'],
  [4, 'planWriteOffVoucher'],
  [5, 'planWriteOffAttachments'],
  [6, 'planWriteOffFuelInvoice']
])

export default {
  name: 'ExecuteReimbursement',
  computed: {
    activityFeeFieldList() {
      return activityFeeFieldList
    },
    activityVisibilityMap() {
      return activityVisibilityMap
    }
  },
  directives: { waves },
  components: {
    ActivityMaintenanceInformation,
    // 活动提报信息
    ActivityReportingInformation,
    checkHistory,
    // activityReimbursement
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      loading: false,
      collapseNumber: 'default',
      activity: {},
      signData: {},
      changeFile: false,
      fileList: {
        actPlanApply: [], // 计划方案
        planWriteOffVatInvoice: [], // 发票
        planWriteOffContract: [], // 合同列表
        planWriteOffTollInvoice: [], // 过路费发票
        planWriteOffVoucher: [], // 费用凭证列表
        planWriteOffAttachments: [], // 核销材料附件列表
        planWriteOffFuelInvoice: []  //  加油费
      },
      fileTypeMap: defaultFileTypeMap,
      findHistTasksData: [],
      findWriteoffTasksData: [],
      // 选择乘龙图片库执行照片上传对话框
      PictureBase: {
        OutBox: false,
        box: false,
        ImageUrl: '',
        disabled: false,
        imgs: [],
        loading: false
      },
      // 对应计划方案，发票，合同，发票真伪查验截图，费用凭证，其他材料附件
      typeList: ['actPlanApply', 'planWriteOffVatInvoice', 'planWriteOffContract',
        'planWriteOffTollInvoice', 'planWriteOffVoucher', 'planWriteOffAttachments', 'planWriteOffFuelInvoice'],
      checkAll: false,
      checkList: {},
      isIndeterminate: false,
      fileInfoList: [], // 文件信息列表
      selectImgInfoList: [], // 已选图片信息列表
      allImgInfoList: [], // 全部图片信息列表
      imgLoading: false,
      SelectLists: {},
      remainFeeFlag: false, // 剩余费用标志，日常推广或新入网支持时为true
      amountData: {
        amountId: null,
        remainFee: null
      },
      downLoading: false,
      officeTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
      // invoicingTime: '', // 开票时间
      // invoicingNumber: null
    }
  },
  async created() {
    // this.SelectListsFun()
    if (this.$route.params.id) {
      this.signData.id = this.$route.params.id
      this.SelectListsFun()
      // 获取提报详情
      this.getMarketactivityById(this.$route.params.id)
    }
  },

  methods: {
    validateActualCost(rule, value, callback) {
    if (value && this.signData.approveApplyCost && value > this.signData.approveApplyCost) {
      //callback(new Error(`实际执行费用不能大于审批申请金额 ${this.signData.approveApplyCost} 元`))
      callback()
    } else {
      callback()
    }
  },
      SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PeriodBudgetCode']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取提报详情
    getMarketactivityById(id) {
      this.loading = true
      getActApplyDetail(id).then(res => {
        if (res.code === 1 && res.data) {
          this.signData = res.data
          this.signData.dealerName = res.data.dealerName
          this.signData.dealerShortName = res.data.orgName
          if (!this.signData.thisWriteoffCost) {
            this.signData.thisWriteoffCost = this.signData.approveApplyCost
            // this.signData.actualCost = this.signData.approveApplyCost
            // this.signData.thisWriteoffCost = this.signData.approveApplyCost * 110100
            // this.activity.writeRate
          }
          this.findWriteoffApprove()
          this.viewApproveDetail()
          this.getActById(this.signData.planDealerId)
          this.getFileInfo()
          this.getPicLibrary()

          if (this.signData.actualCost === null || this.signData.actualCost === '' || this.signData.actualCost === 0) {
            this.getActualCost()
          }

          this.loading = false
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 获取活动详情
    getActById(id) {
      this.loading = true
      const data = {
        id: id,
        planApplyId: this.signData.id
      }
      findDealerActById(data).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
          this.getWriteOffRemainFee()
          this.loading = false
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 获取核销剩余费用(日常推广和新入网支持)
    getWriteOffRemainFee() {
      // this.remainFeeFlag = this.SelectLists.PeriodBudgetCode.some(item => item.code === this.activity.budgetTypeCode)
      if (this.activity.budgetTypeCode === '1' || this.activity.budgetTypeCode === '13') {
        this.remainFeeFlag = true
      }
      if (!this.remainFeeFlag) {
        return
      }
      this.loading = true
      const data = {
        applyPlanId: this.signData.id,
        budgetType: this.activity.budgetTypeCode
      }
      getRemainFee(data).then(res => {
        if (res.code === 1) {
          // this.amountData = res.data
          Object.assign(this.amountData, res.data)
          this.loading = false
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 获取文件信息
    getFileInfo() {
      findFileInfo(this.signData.planApplyCode).then(res => {
        if (res.code === 1 && res.data) {
          this.fileInfoList = res.data
          this.initFile()
        }
      })
    },
    viewApproveDetail() {
      if (this.signData.applyOrderId || this.signData.applyHistOrderId) {
        const param = {
          orderId: this.signData.applyOrderId || this.signData.applyHistOrderId
        }
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.findHistTasksData = res.data
            this.findHistTasksData.forEach(item => {
              if (!item.his) {
                item.operatorName = this.signData.applyAuditorNames
                item.finishTime = '正在处理'
              }
            })
            this.approveAppLoading = false
          }
        })
      }
    },
    findWriteoffApprove() {
      if (this.signData.writeoffOrderId || this.signData.writeoffHistOrderId) {
        const param = {
          orderId: this.signData.writeoffOrderId || this.signData.writeoffHistOrderId
        }
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.findWriteoffTasksData = res.data
            this.findWriteoffTasksData.forEach(item => {
              if (!item.his) {
                item.operatorName = this.signData.writeoffAuditorNames
                item.finishTime = '正在处理'
              }
            })
          }
        })
      }
    },
    // 获取文件byte并放入fileList
    // initFile() {
    //   if (this.fileInfoList.length < 1) {
    //     return
    //   }
    //   this.fileInfoList.forEach(item => {
    //     const file = {
    //       name: item.name,
    //       url: item.path
    //     }
    //     this.fileList[item.module].push(file)
    //   })
    // },

    initFile() {
  if (this.fileInfoList.length < 1) {
    return
  }
  this.fileInfoList.forEach(item => {
    const file = {
      name: item.name,
      url: item.url  // 改为使用 url 而不是 path
    }
    this.fileList[item.module].push(file)
  })
} ,





    // 点击下载文件
    // async onPreviewFun(e) {
    //   let pathUrl = process.env.VUE_APP_API_BASE_URL + '/'
    //   console.log(pathUrl + e.url,e,'---e-----');
    //   if (e.url) {
    //       window.open(pathUrl + e.url, '_blank')
    //     // }
    //   } else {
    //     // 未上传文件
    //     this.exportExcelData(e.raw, e.name)
    //   }
    // },

    async onPreviewFun(e) {
  let pathUrl = process.env.VUE_APP_API_BASE_URL + '/'
  console.log(pathUrl + e.url, e, '---e-----');

  if (e.url) {
    const fileName = e.name
    const suffix = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()

    // 压缩文件类型列表
    const archiveTypes = ['rar', 'zip', '7z', 'tar', 'gz']

    if (archiveTypes.includes(suffix)) {
      // 压缩文件直接下载
      const downloadLink = document.createElement('a')
      downloadLink.href = pathUrl + e.url
      downloadLink.download = fileName
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    } else if (this.officeTypeList.includes(suffix)) {
      // Office文件特殊处理（原有的逻辑）
      const routeData = this.$router.resolve({
        query: { name: e.name, url: e.url },
        path: '/previewFile'
      })
      window.open(routeData.href, '_blank')
    } else {
      // 其它类型直接打开
      window.open(pathUrl + e.url, '_blank')
    }
  } else {
    // 未上传文件
    this.exportExcelData(e.raw, e.name)
  }
} ,



    // 二进制流下载 res 流 name 文件名
    exportExcelData(res, name) {
      // 拿到流 设置格式
      var blob = new Blob([res], { type: 'application/msword,charset=utf-8' })
      // 兼容ie
      if (window.navigator.msSaveOrOpenBlob) {
        // IE 下载文件
        navigator.msSaveBlob(blob, NamedNodeMap)
      } else {
        // 创建a标签
        let ele = document.createElement('a')
        // 通过URL.createObjectURL(blob)可以获取当前文件的一个内存URL 设置下载文件的url地址
        ele.setAttribute('href', URL.createObjectURL(blob))
        // 给a标签设置下载按钮
        ele.setAttribute('download', name)
        // 点击下载开始
        ele.click()
        // 收尾
        ele = null
      }
    },
    // 图片文件获取方法
    downloadFiles(obj) {
      return new Promise(resolve => {
        const path = obj.path
        const name = obj.name
        this.$ComHttp.download({ path, name }).then(blob => {
          resolve(window.URL.createObjectURL(blob))
        })
      })
    },
    // ===================文件上传======================

    handleChange1(file, fileList) {
      console.log(file,fileList,'--0-0-0');

      for (let i = 0; i < this.fileList.planWriteOffVatInvoice.length; i++) {
        if (this.fileList.planWriteOffVatInvoice[i].name === file.name) {

          this.$message.error('文件名重复，请修改文件名后重新上传!')
          fileList.pop()
          return  // 阻止文件上传
        }
      }
      // this.fileList.planWriteOffVatInvoice.push(file); // 将新文件添加到列表中
      this.fileList.planWriteOffVatInvoice.push(file); // 将新文件添加到列表中
      this.fileTypeFlag = 1
      // this.$refs.uploadInvoice.submit()


      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', file.raw)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    handleChange2(file, fileList) {
      this.changeFile = true
      const flag = this.fileList.planWriteOffContract.find(item => item.name === file.name)
      if (flag) {
        this.$message.error('文件名重复，请修改文件名后重新上传!')
        fileList.pop()
        return
      }
      this.fileList.planWriteOffContract = fileList
      this.fileTypeFlag = 2
      this.$refs.uploadContract.submit()
    },
    handleChange3(file, fileList) {
      this.changeFile = true
      // const flag = this.fileList.planWriteOffTollInvoice.find(item => item.name === file.name)
      // if (flag) {
      //   this.$message.error('文件名重复，请修改文件名后重新上传!')
      //   fileList.pop()
      //   return
      // }
      // this.fileList.planWriteOffTollInvoice = fileList
      // this.fileTypeFlag = 3
      // this.$refs.uploadCapture.submit()


      for (let i = 0; i < this.fileList.planWriteOffTollInvoice.length; i++) {
        if (this.fileList.planWriteOffTollInvoice[i].name === file.name) {

          this.$message.error('文件名重复，请修改文件名后重新上传!')
          fileList.pop()
          return  // 阻止文件上传
        }
      }
      this.fileList.planWriteOffTollInvoice.push(file); // 将新文件添加到列表中
      this.fileTypeFlag = 3
      // this.$refs.uploadCapture.submit()

      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', file.raw)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    handleChange4(file, fileList) {
      this.changeFile = true
      const flag = this.fileList.planWriteOffVoucher.find(item => item.name === file.name)
      if (flag) {
        this.$message.error('文件名重复，请修改文件名后重新上传!')
        fileList.pop()
        return
      }
      this.fileList.planWriteOffVoucher = fileList
      this.fileTypeFlag = 4
      this.$refs.uploadVoucher.submit()
    },
    handleChange5(file, fileList) {
      this.changeFile = true
      const flag = this.fileList.planWriteOffAttachments.find(item => item.name === file.name)
      if (flag) {
        this.$message.error('文件名重复，请修改文件名后重新上传!')
        fileList.pop()
        return
      }
      this.fileList.planWriteOffAttachments = fileList
      this.fileTypeFlag = 5
      this.$refs.uploadAttachment.submit()
    },
    handleChange6(file, fileList) {
      this.changeFile = true
      // const flag = this.fileList.planWriteOffFuelInvoice.find(item => item.name === file.name)
      // if (flag) {
      //   this.$message.error('文件名重复，请修改文件名后重新上传!')
      //   fileList.pop()
      //   return
      // }
      // this.fileList.planWriteOffFuelInvoice = fileList
      // this.fileTypeFlag = 6
      // this.$refs.uploadFuelCost.submit()


      for (let i = 0; i < this.fileList.planWriteOffFuelInvoice.length; i++) {
        if (this.fileList.planWriteOffFuelInvoice[i].name === file.name) {

          this.$message.error('文件名重复，请修改文件名后重新上传!')
          fileList.pop()
          return  // 阻止文件上传
        }
      }
      this.fileList.planWriteOffFuelInvoice.push(file); // 将新文件添加到列表中
      this.fileTypeFlag = 6
      // this.$refs.uploadFuelCost.submit()

      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', file.raw)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    handleRemove1(file, fileList) {
      this.changeFile = true
      if (file.status === 'success') {
        const params = {
          name: file.name,
          code: this.signData.planApplyCode,
          module: this.typeList[1]
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.fileList.planWriteOffVatInvoice = fileList
    },
    handleRemove2(file, fileList) {
      this.changeFile = true
      if (file.status === 'success') {
        const params = {
          name: file.name,
          code: this.signData.planApplyCode,
          module: this.typeList[2]
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.fileList.planWriteOffContract = fileList
    },
    handleRemove3(file, fileList) {
      this.changeFile = true
      if (file.status === 'success') {
        const params = {
          name: file.name,
          code: this.signData.planApplyCode,
          module: this.typeList[3]
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.fileList.planWriteOffTollInvoice = fileList
    },
    handleRemove4(file, fileList) {
      this.changeFile = true
      if (file.status === 'success') {
        const params = {
          name: file.name,
          code: this.signData.planApplyCode,
          module: this.typeList[4]
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.fileList.planWriteOffVoucher = fileList
    },
    handleRemove5(file, fileList) {
      this.changeFile = true
      if (file.status === 'success') {
        const params = {
          name: file.name,
          code: this.signData.planApplyCode,
          module: this.typeList[5]
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.fileList.planWriteOffAttachments = fileList
    },
    handleRemove6(file, fileList) {
      this.changeFile = true
      if (file.status === 'success') {
        const params = {
          name: file.name,
          code: this.signData.planApplyCode,
          module: this.typeList[6]
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
      }
      this.fileList.planWriteOffFuelInvoice = fileList
    },


    // submitUpload(type) {
    //   this.fileTypeFlag = type
    //   if (type === 1) {
    //     this.$refs.uploadInvoice.submit()
    //   }
    //   if (type === 2) {
    //     this.$refs.uploadContract.submit()
    //   }
    //   if (type === 3) {
    //     this.$refs.uploadCapture.submit()
    //   }
    //   if (type === 4) {
    //     this.$refs.uploadVoucher.submit()
    //   }
    //   if (type === 5) {
    //     this.$refs.uploadAttachment.submit()
    //   }
    // },
    uploadHttpRequest1(param) {
      console.log(param,'---------param-------');

      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1 && res.message === '上传成功') {
          this.$message.success('上传成功')
        } else if (res.code === 1 && res.message !== '上传成功') {
          this.$message.success(res.message)
        }
      })
    },
    uploadHttpRequest2(param) {
      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    uploadHttpRequest3(param) {
      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1 && res.message === '上传成功') {
          this.$message.success('上传成功')
        } else if (res.code === 1 && res.message !== '上传成功') {
          this.$message.success(res.message)
        }
      })
    },
    uploadHttpRequest4(param) {
      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1 && res.message === '上传成功') {
          this.$message.success('上传成功')
        } else if (res.code === 1 && res.message !== '上传成功') {
          this.$message.success(res.message)
        }
      })
    },
    uploadHttpRequest5(param) {
      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    uploadHttpRequest6(param) {
      const formData = new FormData()
      const data = {
        type: this.fileTypeMap.get(this.fileTypeFlag),
        code: this.signData.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1 && res.message === '上传成功') {
          this.$message.success('上传成功')
        } else if (res.code === 1 && res.message !== '上传成功') {
          this.$message.success(res.message)
        }
      })
    },
    // 文件上传之前的操作
    beforeUpload(file,fileList) {
      console.log(fileList,'-----文件上传之前的操作----');

      // 文件大小限制为20M
      const fileLimit = file.size / 1024 / 1024 < 50
      if (!fileLimit) {
        this.$message.warning('上传文件大小不超过40M！')
      }
      // 返回判断条件,false停止上传
      return fileLimit
    },
    beforeRemove1() {
      // return this.$confirm('确定删除文件"' + file.name + '"?')
    },
    beforeRemove2() {
      // return this.$confirm('确定删除文件"' + file.name + '"?')
    },
    beforeRemove3() {
      // return this.$confirm('确定删除文件"' + file.name + '"?')
    },
    beforeRemove4() {
      // return this.$confirm('确定删除文件"' + file.name + '"?')
    },
    beforeRemove5() {
      // return this.$confirm('确定删除文件"' + file.name + '"?')
    },
    beforeRemove6() {
      // return this.$confirm('确定删除文件"' + file.name + '"?')
    },
    // 保存信息
    saveFun() {
      this.$refs.formOne.validate(val => {
        if (!val) {
          this.$message.error('完善核销信息')
          return
        }
        //if (this.remainFeeFlag && (this.amountData.amountId === null || this.amountData.amountId === '')) {
        //  this.$message.error('未获取到符合当前日期费用，请联系厂家维护费用')
        //  return
        //}
        // 校验核销审核费用是否为0
        const writeoffApproveFee = this.signData.actualCost * (this.activity.writeRate / 100)
        if (writeoffApproveFee === 0 || writeoffApproveFee === null || writeoffApproveFee === undefined) {
          this.$message.warning('您申请的核销金额为0，请重新填写后再提交。')
          return
        }
        this.submint()
      })
    },
    // 提交后端
    submint() {
      this.loading = true
      this.$delete(this.signData, 'actButget');
      this.signData.writeoffProportion = this.activity.writeRate
      const data = Object.assign({}, this.signData)
      console.log(data,'反馈保存入参');

      saveWriteOffInfo(data).then(res => {
        if (res.code === 1) {
          // this.onUploadPlanFiles()
          this.loading = false
          this.$message.success(res.message)
          this.ReturnFun(1)
        } else {
          this.loading = false
          this.$message.warning(res.message)
        }
      })
    },
    // 文件上传
    onUploadPlanFiles() {
      for (var item in this.fileList) {
        // 跳过执行计划
        if (item === 'actPlanApply') {
          continue
        }
        const files = this.fileList[item]
        if (files.length < 1) {
          continue
        }
        const formData = new FormData()
        files.forEach(val => {
          if (val.raw) {
            formData.append('file', val.raw)
          }
        })
        const data = {
          type: item,
          code: this.signData.planApplyCode
        }
        const params = JSON.stringify(data)
        formData.append('params', new Blob([params], { type: 'application/json' }))
        uploadPlanFiles(formData).then(() => {
        })
      }
    },
    deleteRouter() {
      // 删除上个标签页
      const visitedViews = this.$store.state.tagsView.visitedViews
      this.$store.state.tagsView.visitedViews = visitedViews.filter(v => {
        return v.path !== this.$route.path
      })
    },
    ReturnFun() {
      // 跳路由
      this.$closePage('/terminalActivity/executeReimbursement', '/terminalActivity/activityReimbursement')
    },
    // 乘龙图片库执行照片上传确定方法
    PictureBaseFun() {
      if (this.allImgInfoList.length < 1) {
        return
      }
      this.imgLoading = true
      const fileNames = this.allImgInfoList.filter(item => item.checked === true).map(item => item.name)
      const data = {
        code: this.signData.planApplyCode,
        fileNames: fileNames
      }
      confirmPictures(data).then(res => {
        if (res.code === 1) {
          this.imgLoading = false
          this.getPicLibrary()
          this.$message.success(res.message)
          this.PictureBase.OutBox = false
        }
      })
    },
    // 获取图片信息
    getPicLibrary() {
      this.allImgInfoList = []
      this.selectImgInfoList = []
      const data = { planApplyCode: this.signData.planApplyCode }
      getCameraPictures(data).then(res => {
        if (res.code === 1 && res.data) {
          this.allImgInfoList = res.data
          this.getImagesUrl()
        }
      })
    },
    // 拼接图片url
    getImagesUrl() {
      this.allImgInfoList.forEach(item => {
        // item.url = this.baseUrl + '/ACTIVITY-SERVE/act-plan-apply/getFileByte2?path=' + item.path
        if (item.isSelect === '1') {
          this.selectImgInfoList.push(item)
        }
      })
    },
    // 打开图片列表
    async openPicDialog() {
      // checkbox赋值
      this.allImgInfoList.forEach(item => {
        item.checked = false
        const flag = this.selectImgInfoList.find(val => val.id === item.id)
        if (flag) {
          item.checked = true
        }
      })
      const checkedCount = this.selectImgInfoList.length
      this.checkAll = checkedCount === this.allImgInfoList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allImgInfoList.length
      this.PictureBase.OutBox = true
    },
    // 图片全选
    handleCheckAllChange(val) {
      this.allImgInfoList.forEach(item => {
        item.checked = val
      })
      this.isIndeterminate = false
    },
    // 选择图片
    handleCheckedImgsChange() {
      const checkedCount = this.allImgInfoList.filter(item => item.checked === true).length
      this.checkAll = checkedCount === this.allImgInfoList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allImgInfoList.length
      this.$forceUpdate() // 强制更新视图
    },
    // 取消选择图片
    onCancelSelect() {
      this.PictureBase.OutBox = false
      this.isIndeterminate = false
      this.checkAll = false
    },
    // 下载全部图片
    async onDownloadPic(type) {
      this.downLoading = true
      let downloadList = []
      let zipName = null
      if (type === 0) {
        downloadList = this.selectImgInfoList
        zipName = this.signData.planApplyCode + '_' + '执行照片(已选)'
      } else {
        downloadList = this.allImgInfoList
        zipName = this.signData.planApplyCode + '_' + '执行照片(全部)'
      }
      // 创建一个新的 JSZip 实例
      const zip = new JSZip()

      // 创建一个 Promise 数组以将图像添加到压缩包
      const promises = downloadList.map((imageInfo) => {
        return fetch(imageInfo.url)
          .then(response => response.blob())
          .then(blob => {
          // 添加图像到压缩包
            zip.file(imageInfo.name, blob)
          })
      })

      // 所有图像处理完成后生成压缩包
      Promise.all(promises)
        .then(() => {
        // 生成压缩包的二进制数据
          return zip.generateAsync({ type: 'blob' })
        })
        .then((blob) => {
        // 创建一个隐藏的<a>元素来下载压缩包
          const downloadLink = document.createElement('a')
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download = zipName // 压缩包文件名
          document.body.appendChild(downloadLink)
          downloadLink.click()
          document.body.removeChild(downloadLink) // 清理<a>元素
          this.downLoading = false
        })
        .catch((error) => {
          console.error('Error while creating the zip:', error)
        })
    },
    async onTimeChange(e) {
      const param =  {
        kpsjBegin: e[0],
        kpsjEnd: e[1],
        orgid: this.activity.dealerId // 经销商id
      }
      const res = await getCarInvoiceCount(param)
      console.log("🚀 ~ onTimeChange ~ res:", res)
      this.invoicingNumber = res.data.count
    },
    // 输入有变化则重新计算
    getActualCost() {
      this.signData.actualCost = Number(this.signData.actualConferenceFee) + Number(this.signData.actualFuelCost)
          + Number(this.signData.actualToll) + Number(this.signData.actualGiftFee) + Number(this.signData.actualMoveInFee) + Number(this.signData.actualMakeCost)
          + Number(this.signData.actualSiteRent) + Number(this.signData.actualAnnualFee) + Number(this.signData.actualOtherFee)
    },
    // 失焦时为空则变0
    setZeroIfEmpty(f) {
      if (this.signData[f] === null || this.signData[f] === undefined || this.signData[f] === '') {
        this.$set(this.signData, f, 0);   // 保证响应式
      }
    },
    // 发起界面，暂时无作用
    isDisabled() {
      return this.formType === 'detail'
    },
    // 使用这个映射来通过活动类型获取使用的表单
    getFormByActivity(activityType) {
      // 遍历映射对象
      for (const form in activityFormMap) {
        // 检查活动类型是否在当前表单类型的数组中
        if (activityFormMap[form].includes(activityType)) {
          return form;
    }
  }
      // 如果没有找到对应的表单，返回"未知表单"
      return "form1";
    },
  }
}
</script>
<style lang="less" scoped>
.item-line {
  padding: 0px 20px;
  width: 100%;
  margin: 0;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
.execute-reimbursement {
  .imgbox {
    width: 80% !important;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: #b5b5b5;
      border-radius: 20px;
    }
    /deep/ .el-table__body-wrapper {
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background: #b5b5b5;
        border-radius: 20px;
        width: 200px;
      }
    }
  }
  .collapse-box {
    margin-top: 10px;
    border: 1px solid #cccccc;
  }
  .collapseItem {
    /deep/ .el-collapse-item__header {
      padding: 0px 20px;
      width: 100%;
      margin: 0;
      background: #0a76a4;
      color: #ffffff;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
    }
    /deep/ .el-collapse-item__content {
      padding-top: 20px;
      padding-right: 20px;
    }
  }
  .fixedButton {
    width: 100%;
    margin: 0;
    padding: 0 5px 5px;
    .examineButton {
      margin: 0 10px 0 0;
    }
  }
  .ActivityPlanReviewExamine {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 5px 5px 5px;
    // border-top: 1px solid rgb(201, 201, 201);
    .budgetBox {
      margin: 0 0 20px;
      padding: 10px 10px 20px;
      border: 1px solid #cccccc;
    }
    .blueTitle {
      height: 30px;
      background: #0a76a4;
      padding: 6px 30px;
      margin: 10px 0 0;
      color: white;
    }
    .form-item {
      display: inline-block;
      // margin: 0 10px 10px 0;
    }
  }
  .picDialog {
    height: 400px;
    overflow-y: auto;
  }
  .image-item {
    width: 200px;
    height: 200px;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    position:relative;
    padding-left: 5px;
  }
  .pic-box {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    height: 210px;
    overflow-y: auto;
  }
  .image-item2 {
    width: 200px;
    height: 200px;
    display: inline-block;
    box-sizing: border-box;
    padding: 5px;
    text-align: center;
  }
  .null-tip {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: rgb(193 192 192);
  }
  /deep/ .el-input__inner {
    height: 30px!important;
  }
  /deep/ .el-range-separator {
    /* padding: 0 5px; */
    line-height: 20px;
    width: 5%;
    color: #303133;
  }
  /deep/ .el-icon-date {
    display: none;
  }
}

</style>
